import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GoodsHistoryItem {
    product_history_idx: number;
    m_name: string | null;
    method_code: number | null;
    contents: string;
    reg_date: string;
}

export interface GetGoodsHistoryResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: GoodsHistoryItem[];
}

/* 구분코드 (be: enumConfig.productHistoryStatus) */
export const goodsHistoryMethod: Record<number, string> = {
    1: "등록",
    2: "수정",
    3: "삭제",
    4: "복구",
};

export const useGetGoodsHistory = (
    productIdx: number | null,
    page: number,
): UseQueryResult<GetGoodsHistoryResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetGoodsHistoryResponse, Error>({
        queryKey: ["getGoodsHistory", productIdx, page],
        /* 상품을 고르기 전 빈 수정 폼은 productIdx 0 으로 뜬다. 그때는 부르지 않는다 */
        enabled: !!productIdx,
        queryFn: async () => {
            const url = enum_api_uri.get_product_history.replace(":product_idx", String(productIdx));

            const response = await axios.get(`${url}?page=${page}&limit=20`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
